import { declareString } from "@1js/localization";

export const PromptRemovedTitle = declareString(
  "promptLibrary.promptRemovedToastTitle",
  {
    text: "Bookmark removed",
    comment:
      "Title of the toast notification that appears on the page after users remove a user-authored Copilot prompt",
  }
);

export const PromptRemovedText = declareString(
  "promptLibrary.promptRemovedToastText",
  {
    text: "If you shared this prompt with someone in your organization, they can still see it in Copilot Lab.",
    comment:
      "Text of the toast notification that appears on the page after users remove a user-authored Copilot prompt",
  }
);

export const PromptRemovedUndo = declareString(
  "promptLibrary.promptRemovedToastUndo",
  {
    text: "Undo",
    comment:
      "Undo button's label on the toast notification that appears on the page after users remove a user-authored Copilot prompt",
  }
);

export const PromptRemovedErrorText = declareString(
  "promptLibrary.promptRemovedToastError",
  {
    text: "Couldn't remove prompt, try again later",
    comment: `Text shown on a toast notification when the user tries to delete a Copilot prompt they have already saved and it fails.`,
  }
);

export const PromptSharedToTeamToastTitle = declareString(
  "promptLibrary.promptSharedToTeamToastTitle",
  {
    text: "Prompt shared to team",
    comment:
      "Title of the toast notification that appears on the page after user shared a prompt with a workgroup.",
  }
);

export const PromptSharedToTeamsToastTitle = declareString(
  "promptLibrary.promptSharedToTeamsToastTitle",
  {
    text: "Prompt shared to teams",
    comment:
      "Title of the toast notification that appears on the page after user shared a prompt with multiple workgroups.",
  }
);

export const PromptSharedToTeamToastLinkLabel = declareString(
  "promptLibrary.promptSharedToTeamToastLinkLabel",
  {
    text: "View in Team Prompts",
    comment:
      "Link of the toast notification that appears on the page after user shared a prompt with a workgroup.",
  }
);

export const PromptSharedToTeamToastErrorTitle = declareString(
  "promptLibrary.promptSharedToTeamToastErrorTitle",
  {
    text: "Couldn't share prompt. Try again later.",
    comment:
      "Title of the toast notification that appears on the page after user shared a prompt with a workgroup unsuccessfully.",
  }
);

export const PromptRemovedFromTeamToastTitle = declareString(
  "promptLibrary.promptRemovedFromTeamToastTitle",
  {
    text: "Prompt removed",
    comment:
      "Title of the toast notification that appears on the page after user removed a prompt with a workgroup.",
  }
);

export const PromptRemoved = declareString("promptLibrary.promptRemoved", {
  text: "Prompt removed",
  comment:
    "Title of the toast notification that appears on the page after user removed a saved prompt.",
});

export const PromptRemovedFromTeamToastErrorTitle = declareString(
  "promptLibrary.promptRemovedFromTeamToastErrorTitle",
  {
    text: "Couldn't remove prompt. Try again later.",
    comment:
      "Title of the toast notification that appears on the page after user removed a prompt with a workgroup unsuccessfully.",
  }
);

export const TeamPromptFetchingErrorTitle = declareString(
  "promptLibrary.teamPromptFetchingErrorTitle",
  {
    text: "Error fetching team prompts",
    comment:
      "Title of the toast notification that appears on the page after we failed to fetch team prompts.",
  }
);
